class AccessoriesSelector {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.initShowLess();
    this.injectSelectedCount();
    this.bindCheckboxEvents();
    this.updateSelectedCount();
    this.bindAddToCart();
    this.bindAccessoryClick();
  }

  // 绑定"更多/收起"按钮的点击
  bindEvents() {
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("show-more-btn")) {
        this.showMoreAccessories(e.target);
      } else if (e.target.classList.contains("show-less-btn")) {
        this.showLessAccessories(e.target);
      }
    });
  }

  // 绑定附件点击事件
  bindAccessoryClick() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".accessory-clickable")) {
        e.preventDefault();
        e.stopPropagation();

        const accessoryItem = e.target.closest(".accessory-item");
        if (accessoryItem) {
          this.showAccessoryModal(accessoryItem);
        }
      }
    });
  }

  // 显示附件弹窗
  showAccessoryModal(accessoryItem) {
    const productId = accessoryItem.dataset.productId;
    const productTitle = accessoryItem.dataset.productTitle;
    const productPrice = accessoryItem.dataset.productPrice;
    const productDescription = accessoryItem.dataset.productDescription;
    const productImage = accessoryItem.dataset.productImage;
    const productUrl = accessoryItem.dataset.productUrl;
    const productVariantId = accessoryItem.dataset.productVariantId;

    // 移除已存在的弹窗
    this.removeExistingModal();

    // 创建遮罩
    const overlay = document.createElement("div");
    overlay.className = "accessory-modal-overlay open";

    // 创建弹窗
    const modal = document.createElement("div");
    modal.className = "accessory-modal open";

    // 构建弹窗内容
    const imageHtml =
      productImage && productImage !== ""
        ? `<img src="${productImage}" alt="${productTitle}" class="accessory-modal-image">`
        : '<div class="accessory-modal-image" style="display:flex;align-items:center;justify-content:center;color:#9ca3af;">Kein Bild verfügbar</div>';

    const descriptionHtml =
      productDescription && productDescription !== ""
        ? `<div class="accessory-modal-description">${productDescription}</div>`
        : '<div class="accessory-modal-description" style="color:#9ca3af;">Keine Beschreibung verfügbar</div>';

    modal.innerHTML = `
      <div class="accessory-modal-header">
        <h3 class="accessory-modal-title">${productTitle}</h3>
        <button class="accessory-modal-close" type="button">&times;</button>
      </div>
      <div class="accessory-modal-content">
        ${imageHtml}
        <div class="accessory-modal-price">${productPrice}</div>
        ${descriptionHtml}
        <div class="accessory-modal-actions">
          <button class="accessory-modal-btn accessory-modal-btn-secondary" data-action="view-details" data-url="${productUrl}">
            Details anzeigen
          </button>
          <button class="accessory-modal-btn accessory-modal-btn-primary" data-action="add-to-cart" data-variant-id="${productVariantId}">
            Zum Warenkorb hinzufügen
          </button>
        </div>
      </div>
    `;

    // 添加到页面
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
    document.body.classList.add("accessory-modal-open");

    // 绑定关闭事件
    this.bindModalEvents(modal, overlay);
  }

  // 绑定弹窗事件
  bindModalEvents(modal, overlay) {
    const closeBtn = modal.querySelector(".accessory-modal-close");
    const viewDetailsBtn = modal.querySelector('[data-action="view-details"]');
    const addToCartBtn = modal.querySelector('[data-action="add-to-cart"]');

    // 关闭弹窗
    const closeModal = () => {
      modal.remove();
      overlay.remove();
      document.body.classList.remove("accessory-modal-open");
    };

    // 点击遮罩关闭
    overlay.addEventListener("click", closeModal);

    // 点击关闭按钮
    closeBtn.addEventListener("click", closeModal);

    // 查看详情
    viewDetailsBtn.addEventListener("click", (e) => {
      const url = e.target.dataset.url;
      if (url) {
        window.open(url, "_blank");
      }
    });

    // 添加到购物车
    addToCartBtn.addEventListener("click", (e) => {
      const variantId = e.target.dataset.variantId;
      if (variantId) {
        this.addAccessoryToCart(variantId);
      }
    });

    // ESC键关闭
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });
  }

  // 添加附件到购物车
  addAccessoryToCart(variantId) {
    const addToCartBtn = document.querySelector('[data-action="add-to-cart"]');
    const originalText = addToCartBtn.textContent;

    // 显示加载状态
    addToCartBtn.textContent = "Wird hinzugefügt...";
    addToCartBtn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          // 添加失败
          addToCartBtn.textContent = "Fehler";
          setTimeout(() => {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 2000);
        } else {
          // 添加成功
          addToCartBtn.textContent = "Hinzugefügt!";
          addToCartBtn.style.background = "#10b981";

          // 更新购物车数量（如果有购物车图标的话）
          this.updateCartCount();

          setTimeout(() => {
            // 关闭弹窗
            const modal = document.querySelector(".accessory-modal");
            const overlay = document.querySelector(".accessory-modal-overlay");
            if (modal && overlay) {
              modal.remove();
              overlay.remove();
              document.body.classList.remove("accessory-modal-open");
            }
          }, 1500);
        }
      })
      .catch((err) => {
        console.error("添加附件到购物车失败:", err);
        addToCartBtn.textContent = "Fehler";
        setTimeout(() => {
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
        }, 2000);
      });
  }

  // 更新购物车数量
  updateCartCount() {
    // 这里可以添加更新购物车图标的逻辑
    // 例如触发购物车更新事件
    document.dispatchEvent(new CustomEvent("cart:updated"));
  }

  // 移除已存在的弹窗
  removeExistingModal() {
    const existingModal = document.querySelector(".accessory-modal");
    const existingOverlay = document.querySelector(".accessory-modal-overlay");

    if (existingModal) existingModal.remove();
    if (existingOverlay) existingOverlay.remove();
    document.body.classList.remove("accessory-modal-open");
  }

  // 初始化：根据 data-initial-show 隐藏超出项，并控制按钮显示
  initShowLess() {
    document.querySelectorAll(".accessories-list").forEach((list) => {
      const initialShow = parseInt(list.dataset.initialShow) || 3;
      const items = list.querySelectorAll(".accessory-item");
      items.forEach((item, idx) => {
        item.classList.toggle("accessory-hidden", idx >= initialShow);
      });
      const showMoreBtn = list.querySelector(".show-more-btn");
      const showLessBtn = list.querySelector(".show-less-btn");
      if (items.length > initialShow) {
        showMoreBtn && (showMoreBtn.style.display = "inline-block");
        showLessBtn && (showLessBtn.style.display = "none");
      } else {
        showMoreBtn && (showMoreBtn.style.display = "none");
        showLessBtn && (showLessBtn.style.display = "none");
      }
    });
  }

  // 在每个 toggle 区块前面注入一个用来显示已选数量的 <span>
  injectSelectedCount() {
    document.querySelectorAll(".accessories-list").forEach((list) => {
      const toggle = list.querySelector(".accessories-toggle");
      if (toggle && !toggle.querySelector(".selected-count")) {
        const span = document.createElement("span");
        span.className = "selected-count";
        span.textContent = "0 ausgewählt";
        toggle.insertBefore(span, toggle.firstChild);
      }
    });
  }

  // 监听所有附件复选框的勾选变化
  bindCheckboxEvents() {
    document.querySelectorAll(".accessory-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.updateSelectedCount();
      });
    });
  }

  // 计算并更新"已选 X ausgewählt"
  updateSelectedCount() {
    document.querySelectorAll(".accessories-list").forEach((list) => {
      const count = list.querySelectorAll(".accessory-checkbox:checked").length;
      const span = list.querySelector(".selected-count");
      if (span) span.textContent = `${count} ausgewählt`;
    });
  }

  // 展开全部附件
  showMoreAccessories(button) {
    const list = button.closest(".accessories-list");
    const hiddenItems = list.querySelectorAll(
      ".accessory-item.accessory-hidden"
    );
    hiddenItems.forEach((i) => i.classList.remove("accessory-hidden"));
    button.style.display = "none";
    const showLessBtn = list.querySelector(".show-less-btn");
    showLessBtn && (showLessBtn.style.display = "inline-block");
  }

  // 收起超出附件
  showLessAccessories(button) {
    const list = button.closest(".accessories-list");
    const allItems = list.querySelectorAll(".accessory-item");
    const initialShow = parseInt(list.dataset.initialShow) || 3;
    allItems.forEach((item, idx) => {
      item.classList.toggle("accessory-hidden", idx >= initialShow);
    });
    button.style.display = "none";
    const showMoreBtn = list.querySelector(".show-more-btn");
    showMoreBtn && (showMoreBtn.style.display = "inline-block");
  }

  // 全局拦截所有产品表单提交，先添加主商品，再依次添加附件
  bindAddToCart() {
    document.addEventListener("submit", this.handleSubmit.bind(this), {
      capture: true,
    });
  }

  // 处理提交：拦截默认提交，逐一调用 /cart/add.js
  handleSubmit(e) {
    // 只针对我们的 add-to-cart 表单
    if (!e.target.matches('form[data-type="add-to-cart-form"]')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const form = e.target;
    const fd = new FormData(form);
    const mainId = parseInt(fd.get("id"), 10);
    const mainQty = parseInt(fd.get("quantity") || 1, 10);

    if (!mainId) {
      console.warn("无法获取主商品 variant ID");
      return;
    }

    // 收集所有已勾选的附件 variant IDs
    const accessories = Array.from(
      document.querySelectorAll(".accessory-checkbox:checked")
    )
      .map((cb) => {
        const vid = parseInt(cb.dataset.accessoryVariantId, 10);
        return vid ? { id: vid, quantity: 1 } : null;
      })
      .filter(Boolean);

    // 整理添加队列：主商品在前，附件在后
    const itemsToAdd = [{ id: mainId, quantity: mainQty }, ...accessories];

    // 单条添加函数，失败时记录但不中断
    const addOne = ({ id, quantity }) =>
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity }),
      })
        .then((res) => {
          if (!res.ok) {
            console.warn(`Item ${id} 添加失败，状态码 ${res.status}`);
          }
          // 尝试解析返回（不一定要用）
          return res.json().catch(() => {});
        })
        .catch((err) => {
          console.warn(`网络错误，添加 item ${id} 时出错：`, err);
        });

    // 串行执行添加，确保主商品先进，再是所有附件
    itemsToAdd
      .reduce((promiseChain, item) => {
        return promiseChain.then(() => addOne(item));
      }, Promise.resolve())
      .then(() => {
        // 全部尝试完成后再跳转到购物车
        window.location.href = "/cart";
      })
      .catch((err) => {
        console.error("添加流程中发生错误：", err);
        window.location.href = "/cart";
      });
  }
}

document.addEventListener("DOMContentLoaded", () => new AccessoriesSelector());
